import { useEffect, useState } from "react";
import styled from "styled-components";
import { Colors } from "../../ColorConstants";
import { PaginationLayout } from "./PaginationLayout";

export const Pagination = ({
  isTableDataLoading,
  totalData,
  currentPage,
  rowsPerPage,
  totalPages,
  onPageChange,
}) => {
  const [activePages, setActivePages] = useState([]);
  let firstIndex = (currentPage - 1) * rowsPerPage + 1;
  let lastIndex =
    currentPage * rowsPerPage +
    (totalPages === currentPage ? (totalData % rowsPerPage) - rowsPerPage : 0);

  useEffect(() => {
    let paginationArray = generateForwardArray(1, 5, totalPages);
    setActivePages(paginationArray);
  }, [totalPages]);

  const generateForwardArray = (start, count, totalPages) => {
    const end = Math.min(start + count - 1, totalPages);
    const pageArray = [];
    for (let i = start; i <= end; i++) {
      pageArray.push(i);
    }
    return pageArray;
  };

  const handlePageChange = (page) => {
    onPageChange(page);
  };

  return (
    <StyledPaginationLayout>
      <PaginationText>
        {firstIndex}-{lastIndex}
        {" of"} {totalData}
        {totalData === 1 ? " item" : " items"}
      </PaginationText>
      <PaginationLayout
        onPageChange={handlePageChange}
        isTableDataLoading={isTableDataLoading}
        totalData={totalData}
        currentPage={currentPage}
        rowsPerPage={rowsPerPage}
        totalPages={totalPages}
        activePages={activePages}
      ></PaginationLayout>
    </StyledPaginationLayout>
  );
};

const StyledPaginationLayout = styled.span`
  display: flex;
  width: 64rem;
  justify-content: flex-end;
  align-items: center;
  margin-top: 8rem;
  @media only screen and (max-width: 768px) {
    display: none;
  }
`;

const PaginationText = styled.p`
  margin-right: 1.25rem;
  font-weight: 400;
  font-size: 12px;
  color: ${Colors.black};
`;
